module.exports = __webpack_public_path__ + "img/fitness_thumbnail.2fbdbadd.jpg";